<div class="municipal-regulations">

  <!-- Header + Dropdown -->
  <div class="header-section">
    <h2 class="main-title">{{ 'reports.TITLE' | translate }}</h2>

    <ng-container>

      <!-- Multiple Parcels -->
      <div class="parcel-selector" *ngIf="parcels.length > 1">
        <div class="custom-select">
          <div class="select-box" (click)="toggleDropdown()" [class.open]="dropdownOpen">
            <div class="selected-value">
              {{ getSelectedParcelName() || ('reports.SELECT_PARCEL' | translate) }}
            </div>
            <img src="assets/images/Indicator.svg" class="select-arrow" />

            <div class="options-container" *ngIf="dropdownOpen">
              <input
                *ngIf="parcels.length > 10"
                type="text"
                class="parcel-search-inside"
                [(ngModel)]="searchTerm"
                (ngModelChange)="onSearchChange()"
                (click)="$event.stopPropagation()"
                (keydown)="$event.stopPropagation()"
                [placeholder]="'reports.SEARCH_PARCEL' | translate"
              />

              <div class="options-list">
                <div
                  *ngFor="let p of filteredParcels"
                  class="option" [ngClass]="{'active-parcel': p.parcel_uid === selectedParcelUidInternal}"
                  (click)="selectParcel(p.parcel_uid); $event.stopPropagation()">
                  {{ p.parcel_number }}
                </div>

                <div class="no-results" *ngIf="filteredParcels.length === 0">
                  {{ 'reports.NO_PARCELS_FOUND' | translate }}
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <!-- Single Parcel -->
      <!-- <div class="parcel-selector" *ngIf="parcels.length === 1">
        <div class="custom-select">
          <div class="select-box">
            <div class="selected-value">{{ parcels[0].parcel_number }}</div>
            <img src="assets/images/Indicator.svg" class="select-arrow" />
          </div>
        </div>
      </div> -->

    </ng-container>
  </div>

  <!-- Loader -->
  <ng-container *ngIf="loading">
    <div class="municipal-loader">
      <app-skeleton-loader
        [reportType]="reportsChartEnum.tableView"
        [loaderSize]="4">
      </app-skeleton-loader>
    </div>
  </ng-container>

  <!-- Data -->
  <ng-container *ngIf="!loading && currentParcelData?.length">

    <div class="permissible-usage-sections" *ngIf="!isNotSection()">
      <ng-container *ngFor="let usage of currentParcelData; let i = index">

        <div class="usage-section" *ngIf="usage.permitted_use_en">

          <!-- Title -->
          <h3 class="usage-title">
            {{ 'reports.PERMISSIBLE_USAGE' | translate }} ({{ i + 1 }}):
            <span>{{ getPermittedUse(usage) }}</span>
          </h3>

          <!-- TABLE -->
          <div class="table-wrapper" *ngIf="hasFloorData(usage)">
            <table class="regulations-table">

              <thead>
                <tr>
                  <th></th>
                  <ng-container *ngFor="let floor of floors">
                    <th *ngIf="usage[floor] > 0">
                      {{ ('reports.' + floor.toUpperCase()) | translate }}
                    </th>
                  </ng-container>
                </tr>
              </thead>

              <tbody>
                <!-- No of Floors -->
                <tr>
                  <td class="label-col">
                    <strong>{{ 'reports.NO_OF_FLOORS' | translate }}</strong>
                  </td>

                  <ng-container *ngFor="let floor of floors">
                   <td *ngIf="usage[floor] > 0">
                    {{ usage[floor] }}

                    <span
                      *ngIf="usage[floor + '_included'] === 'FALSE'"
                      class="far-star">
                      *
                    </span>
                  </td>

                  </ng-container>
                </tr>

                <!-- Coverage -->
                <tr>
                  <td class="label-col">
                    <strong>{{ 'reports.GROUND_COVERAGE' | translate }}</strong>
                  </td>

                  <ng-container *ngFor="let floor of floors">
                    <td *ngIf="usage[floor] > 0">
                      <!-- {{ usage[floor + '_coverage'] ? (usage[floor] * usage[floor + '_coverage'])+'%' : '-'}} -->
                        <!-- multiply floor logic remove approved by Roobesh sir on call -->
                      {{ usage[floor + '_coverage'] ? (usage[floor + '_coverage'])+'%' : '-'}}
                    </td>
                  </ng-container>
                </tr>
              </tbody>

            </table>
          </div>

          <!-- FAR -->
          <div class="far-row">
            <div class="far-label">
              <strong>{{ 'reports.FAR' | translate }}</strong>
            </div>
            <div class="far-value">{{ usage.far ? usage.far : '-'}}</div>
          </div>
          <div class="far-note" *ngIf="hasFarExcluded(usage)">
              * {{ 'reports.NOT_INCLUDED_IN_FAR' | translate }}
            </div>

          <!-- Floor Regulations -->
          <div class="regulations-section" *ngIf="hasFloorRegulations(usage)">
            <h4>{{ 'reports.FLOOR_REGULATIONS' | translate }}</h4>
            <ul class="bullet-list">
              <li *ngFor="let rule of getRegulationItems(getFloorRegulation(usage))">
                {{ rule }}
              </li>
            </ul>
          </div>

          <!-- Building Regulations -->
          <div class="regulations-section" *ngIf="hasBuildingRegulations(usage)">
            <h4>{{ 'reports.BUILDING_REGULATIONS' | translate }}</h4>
            <ul class="bullet-list">
              <li *ngFor="let rule of getRegulationItems(getBuildingRegulation(usage))">
                {{ rule }}
              </li>
            </ul>
          </div>

        </div>

      </ng-container>
    </div>
    <div *ngIf="isNotSection()" class="no-data-message">
    {{ 'reports.NO_DATA' | translate }}
  </div>
  </ng-container>

  <!-- No Data -->
  <div *ngIf="!loading && currentParcelData?.length === 0" class="no-data-message">
    {{ 'reports.NO_DATA' | translate }}
  </div>

</div>
